import React, { Fragment } from 'react'
import { Collapse } from 'antd'
import { isEmpty } from 'lodash'

const { Panel } = Collapse

const SingleView = ({ emptyText, data, getKey, getHeader, children }) => (
  <Fragment>
    <Collapse accordion>
      {isEmpty(data) && <Panel header={emptyText}>{emptyText}</Panel>}
      {!isEmpty(data) &&
        data.map(d => (
          <Panel key={getKey(d)} header={getHeader(d)}>
            {children(d)}
          </Panel>
        ))}
    </Collapse>
    <br />
  </Fragment>
)

export default SingleView



// WEBPACK FOOTER //
// ./src/components/SingleView.js